export class FormElementPosition
{
	static TOP: string = 'TOP';
	static BOTTOM: string = 'BOTTOM';
}